import React, { useState } from "react";

import Update from "./Update";
import Uploader from "./Uploader";
import ChangePassword from "./ChangePassword";

import LoginAs from "../LoginAs";
import UserRoles from "../UserRoles";
import UserGroups from "../UserGroups";
import UserWallet from "../UserWallet";

import {
  Box,
  Grow,
  Card,
  Stack,
  Grid2,
  alpha,
  styled,
  CardHeader,
  CardActions,
  CardActionArea,
  Checkbox,
  Fade,
} from "@mui/material";
import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";

export default function Model({
  size,
  model,
  checked,
  refetch,
  isAssign,
  selectable,
  handleSelect,
  delay,
}) {
  const [remove, setRemove] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timeout, setTimeout] = useState(delay);
  const [initModel, setModel] = useState(model || {});
  const {
    id,
    media,
    firstname,
    lastname,
    cellphone,
    categories,
    all_roles,
    device_token,
  } = initModel;
  const avatar = media.find((x) => x.collection_name === "avatar");

  const { roles } = useSelector((state) => state.auth.userInfo);
  const isSuperAdmin = hasRequiredRole(["superadmin"], roles);

  const onUpdate = (data = {}) => {
    setTimeout(500);
    setModel({ ...model, ...data });
    // refetch();
  };

  const onRemove = (state = true) => {
    setTimeout(500);
    setRemove(state);
  };

  const onLoading = (state = true) => {
    setTimeout(500);
    setLoading(state);
  };

  return (
    <Grow in={!remove} timeout={timeout} unmountOnExit>
      <Grid2 size={size}>
        <Stack direction="row" alignItems="center" columnGap={0.5}>
          <Fade in={selectable || isAssign} unmountOnExit>
            <Checkbox size="small" color="secondary" checked={checked} onChange={handleSelect} />
          </Fade>
          <Card
            sx={{
              width: "100%",
              position: "relative",
              borderColor: checked && "primary.main",
              bgcolor: checked && "action.disabledBackground",
            }}
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <Uploader
                  id={id}
                  media={avatar}
                  refetch={refetch}
                  model="User"
                  collection="avatar"
                  label=""
                  // caption="400 * 400"
                />
              }
              title={`${firstname} ${lastname}`}
              subheader={cellphone}
              action={
                <Stack direction="row" columnGap={0.5}>
                  <Update
                    id={id}
                    onUpdate={onUpdate}
                    onRemove={onRemove}
                    onLoading={onLoading}
                  />
                  {isSuperAdmin && <ChangePassword id={id} refetch={refetch} />}
                </Stack>
              }
            />
            {!isAssign && isSuperAdmin &&(
              <CardActions sx={{ justifyContent: "flex-end" }}>
                <UserRoles
                  ids={id}
                  refetch={refetch}
                  roles={all_roles || []}
                  title="userRoles"
                />
                <UserGroups
                  ids={id}
                  refetch={refetch}
                  groups={categories}
                  title="userGroups"
                />
                <UserWallet ids={id} title="UserWallet" refetch={refetch} />
              </CardActions>
            )}
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: "absolute",
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
            {loading && <StyledBox />}
          </Card>
        </Stack>
      </Grid2>
    </Grow>
  );
}

const StyledBox = styled(Box)(({ theme, color = "primary" }) => ({
  "&::after": {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    position: "absolute",
    backdropFilter: "blur(5px)",
    WebkitBackdropFilter: "blur(5px)", // Fix on Mobile
    backgroundColor: alpha(theme.palette.warning.main, 0.72),
    animation: "ripple 1s ease-in-out infinite alternate",
    content: '""',
  },
  "@keyframes ripple": {
    "0%": {
      opacity: 0.8,
    },
    "100%": {
      opacity: 0.2,
    },
  },
}));
